export const NumberOfPerPage = {
  onLeave: 25,
  checkIn: 25,
  attendance: 25,
  receiveSalary: 25,
  projectManagement: 25,
  bookingManagement: 25,
  lockingManagement: 25,
  apartment: 25,
  apartmentProduct: 10,
  contract: 25,
  ttkq: 25,
  bookingEvent: 25,
  saleOpeningEvent: 25,
  report: 25,
  serviceFee: 25,
  employee: 25,
  employeeGroupRoles: 25,
  relativeFormRequest: 25,
  actionHistoryManagement: 25,
  transferRequests: 25,
  brokerDebtCertificateManagement: 25,
  brokerDebtDisbursementManagement: 25,
  makeupWorkRequest: 25,
  commissionReport: 5,
  deviceActivityLog: 25,
  saleOpeningEventMechanismParameters: 25,
  attendanceSummaryList: 25,
  employeeAttendanceMonth: 25,
  brokerDebtCertificateInLocking: 25,
};

export const LimitDataSelect = 15;
export const LimitEmployeeSelect = 30;

export const StatusData = {
  locking: {
    NEW: "NEW",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
    REFUND: "REFUND",
  },
  ttkq: {
    NEW: "NEW",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
    REFUND: "REFUND",
  },
  hdmb: {
    NEW: "NEW",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
    REFUND: "REFUND",
  },
};

export const DataPlaceOfIdentification = [
  "Cục Cảnh sát quản lý hành chính về trật tự xã hội",
  "Cục Cảnh sát đăng ký quản lý cư trú và dữ liệu Quốc gia về dân cư",
  "Bộ công an",
];

export const COST_ESTIMATETYPE = [
  {
    value: "1",
    label: "Thanh toán tiến độ/ Thanh toán thông thường",
  },
  {
    value: "2",
    label: "Vay vốn ngân hàng/ Hỗ trợ lãi xuất",
  },
  {
    value: "3",
    label: "Thanh toán sớm/ Thanh toán nhanh",
  },
];
